export function conditionalArray<T>(array: (T | false)[]): T[] {
  return array.filter((item) => item !== false) as T[];
}

export function isArrayEmpty<T>(array: T[] | undefined): boolean {
  return !array || (array && !array.length);
}
